<template>
  <div v-if="question.answers[0].body !== null" class="file-question">
    <vcv-link :text="$tr('responses.presentation.download')" :link="linkToFile" />
  </div>
</template>

<script>
import VcvLink from '@/components_new/VcvLink.vue';

export default {
  name: 'VcvResponseFileQuestion',

  components: {
    VcvLink
  },

  props: {
    question: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    linkToFile() {
      if (this.question.answers[0].body !== null) {
        return this.question.answers[0].body;
      }

      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.file-question {
  margin: 20px 0;
}
</style>
